module.exports = __webpack_public_path__ + "assets/img/icon-equipment-purple.9f4f8243.png";